(function ($) {
    let $fn = $(".comp_visual_main");

    if ($fn.length) {
        $fn.on("click","[data-scroll]",()=>{
            $fn.next("section").anchor_anim(500);
        });
    }
})(jQuery);